












import { Component, Vue } from 'vue-property-decorator';
import LoadingCircle from '@/components/global-loaders/circle.vue';

@Component({
  components: {
    LoadingCircle,
  }
})
class GlobalLoader extends Vue {
  get isPendingUpdateSubscription(){
    const addons = Object.values(this.$store.state.billing.addons || {}) as PlanAddon[];
    return addons.find(item=>item.pending) || !!this.$store.state.billing.pending
  }
}
export default GlobalLoader;
